export const SearchIcon = (width = 14, height = 15) => {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.285 10.8601L12.6004 13.1001M11.8537 7.12681C11.8537 10.0134 9.51366 12.3535 6.62706 12.3535C3.74045 12.3535 1.40039 10.0134 1.40039 7.12681C1.40039 4.2402 3.74045 1.90015 6.62706 1.90015C9.51366 1.90015 11.8537 4.2402 11.8537 7.12681Z"
        stroke="#C0C1C2"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  );
};

export const VerticalDotsIcon = (width = 16, height = 16) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 12.1995C8.33137 12.1995 8.60059 12.4687 8.60059 12.8C8.60048 13.1313 8.33131 13.3997 8 13.3997C7.66887 13.3994 7.4005 13.1312 7.40039 12.8C7.40039 12.4688 7.66881 12.1997 8 12.1995ZM8 7.39966C8.33137 7.39966 8.60059 7.66887 8.60059 8.00024C8.60038 8.33144 8.33124 8.59985 8 8.59985C7.66894 8.59964 7.4006 8.33131 7.40039 8.00024C7.40039 7.669 7.66881 7.39987 8 7.39966ZM8 2.59985C8.33124 2.59985 8.60037 2.86827 8.60059 3.19946C8.60059 3.53083 8.33137 3.80005 8 3.80005C7.66881 3.79984 7.40039 3.5307 7.40039 3.19946C7.4006 2.8684 7.66894 2.60006 8 2.59985Z"
        fill="black"
        stroke="black"
        stroke-width="2"
      />
    </svg>
  );
};

export const ProvidersIcon = (width = 16, height = 16) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.25 7.06204C2.25 6.78499 2.39101 6.52508 2.62843 6.36452L8.47843 2.40838C8.79069 2.19721 9.20931 2.19721 9.52157 2.40838L15.3716 6.36452C15.609 6.52508 15.75 6.78499 15.75 7.06204V14.4662C15.75 15.1752 15.1456 15.75 14.4 15.75H3.6C2.85442 15.75 2.25 15.1752 2.25 14.4662V7.06204Z"
        stroke="#4E4F51"
        stroke-width="2"
      />
    </svg>
  );
};

export const BillingsIcon = (width = 16, height = 16) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.8 2.53345H3.24444C2.55716 2.53345 2.00148 3.27231 2.00084 4.03345C2 5.03345 2.55716 6.02234 3.24444 6.02234H16.2222C17.2041 6.02234 18 5.81827 18 6.80011V15.3334C18 16.5117 17.0449 17.4668 15.8667 17.4668H4.13333C2.95513 17.4668 2 16.5117 2 15.3334V4.53345M13.7473 11.0529L13.7333 11.0668"
        stroke="#4E4F51"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const PatientsIcon = (width = 16, height = 16) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 10.417C10.7509 10.417 12.2875 10.7522 13.3486 11.25C14.4882 11.7847 14.7497 12.3249 14.75 12.583C14.75 12.9879 14.5414 13.4849 13.6768 13.9355C12.7791 14.4034 11.2746 14.75 9 14.75C6.72542 14.75 5.22092 14.4034 4.32324 13.9355C3.45863 13.4849 3.25 12.9879 3.25 12.583C3.25027 12.3249 3.51181 11.7847 4.65137 11.25C5.7125 10.7522 7.24914 10.417 9 10.417ZM9 3.25C9.95669 3.25 10.863 4.20363 10.8633 5.25684C10.8633 6.26236 10.0022 7.15625 9 7.15625C7.99785 7.15625 7.13672 6.26236 7.13672 5.25684C7.13695 4.20363 8.04331 3.25 9 3.25Z"
        stroke="#4E4F51"
        stroke-width="2"
      />
    </svg>
  );
};

export const CalenderIcon = ({color = "#C77B34"}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.10835 6.34547H14.5406M5.72824 1.66683V3.19316M5.72824 3.19316L14.5821 3.193M5.72824 3.19316C4.26123 3.19316 3.07212 4.40285 3.07219 5.89524L3.0726 14.9023C3.07267 16.3945 4.26186 17.6042 5.72877 17.6042H14.5827C16.0497 17.6042 17.2389 16.3944 17.2389 14.902L17.2384 5.89499C17.2384 4.4027 16.0491 3.193 14.5821 3.193M14.5821 1.66675V3.193M8.38507 14.4518V9.04753L6.61429 10.3986M13.2547 14.4518V9.04753L11.4839 10.3986"
        stroke={color}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const PlusIcon = (width = 16, height = 16) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 4L8 12M12 8L4 8"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  );
};

export const CheckIcon = ({ background }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="24"
        height="24"
        rx="12"
        fill={background ? background : "#DEB581"}
      />
      <path
        d="M17.3327 8L9.99935 15.3333L6.66602 12"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const CalendarCheckIcon = (className) => {
  return (
    <svg
      width="9"
      height="9"
      viewBox="0 0 9 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.66797 8.30127C6.73904 8.30127 8.41797 6.62234 8.41797 4.55127C8.41797 2.4802 6.73904 0.80127 4.66797 0.80127C2.5969 0.80127 0.917969 2.4802 0.917969 4.55127C0.917969 6.62234 2.5969 8.30127 4.66797 8.30127ZM6.19939 4.02521C6.36909 3.86978 6.38066 3.60622 6.22524 3.43652C6.06982 3.26682 5.80625 3.25524 5.63655 3.41067L4.09819 4.81959L3.69939 4.45435C3.52969 4.29892 3.26612 4.3105 3.1107 4.4802C2.95528 4.6499 2.96685 4.91347 3.13655 5.06889L3.81677 5.69187C3.97603 5.83773 4.22034 5.83773 4.3796 5.69187L6.19939 4.02521Z"
        fill="#B17F34"
      />
    </svg>
  );
};

export const leftArrowIcon = () => {
  return (
    <svg
      width="7"
      height="12"
      viewBox="0 0 7 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 11L1 6L6 1"
        // stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const CloseIcon = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 8.5L8 16.5M16 16.5L8 8.5"
        stroke="#4E4F51"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  );
};  

export const UserProfileIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.39844 18.2168C3.49708 16.3843 5.90495 15.1301 9.66155 15.1301C13.4182 15.1301 15.826 16.3843 16.9247 18.2168M17.6197 13.7406C19.6091 14.7352 20.6037 15.7299 21.5984 17.7193M15.5506 6.1376C16.4867 6.64115 17.1231 7.62991 17.1231 8.7673C17.1231 9.87183 16.523 10.8362 15.631 11.3522M12.6456 8.76727C12.6456 10.4153 11.3096 11.7513 9.66155 11.7513C8.0135 11.7513 6.67749 10.4153 6.67749 8.76727C6.67749 7.11922 8.0135 5.7832 9.66155 5.7832C11.3096 5.7832 12.6456 7.11922 12.6456 8.76727Z"
        stroke="#6A421C"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  );
};

